import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LocationIcon14 = (props: SvgProps) => (
  <Svg
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <Path
      fill="#0058AD"
      fillRule="evenodd"
      d="M3.39 2.222a5.104 5.104 0 0 1 8.714 3.609c0 .582-.062 1.088-.22 1.564-.158.478-.406.903-.751 1.334a.587.587 0 0 1-.011.013L7.33 13.117a.438.438 0 0 1-.66 0L2.876 8.742a.458.458 0 0 1-.01-.013c-.346-.43-.594-.856-.752-1.334-.158-.476-.22-.982-.22-1.564 0-1.354.538-2.652 1.495-3.61ZM7 1.602A4.23 4.23 0 0 0 2.77 5.83c0 .52.056.928.176 1.289.118.357.306.69.598 1.056L7 12.163l3.455-3.987c.292-.366.48-.7.599-1.056.12-.361.175-.768.175-1.29a4.229 4.229 0 0 0-4.23-4.228Zm0 2.916a1.313 1.313 0 1 0 0 2.625 1.313 1.313 0 0 0 0-2.625ZM4.812 5.831a2.188 2.188 0 1 1 4.375 0 2.188 2.188 0 0 1-4.375 0Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default LocationIcon14;
